import React from 'react';
import {PaywallCard} from "./PaywallCard";
import {templateSettings} from "anvil_settings";
import {coreUrls} from "core_src/js/core_urls_config";
import {Button} from "@chakra-ui/react";
import {RichText} from "frontend/wagtail/components/RichText";


/**
 * Component for displaying the subscribe prompt to the user once they have ran out of article views.
 *
 * @param {string} pageUrl - The URL of the page that the subscription wall is blocking access to.
 * @param {boolean} showButton - Whether to show the subscribe button.
 */
export const SubscriptionWall = ({pageUrl, showButton = true}) => {
    return (
        <PaywallCard header={templateSettings.paywall_subscribe_prompt_header} loginNextUrl={pageUrl}>
            <RichText className="subscription-wall__text" data={templateSettings.paywall_subscribe_prompt_text}/>
            {
                (coreUrls.paywall_order_tunnel && showButton) &&
                <Button
                    as={"a"}
                    href={coreUrls.paywall_order_tunnel}
                    data-visibility-tracker="DisplaySubscribePrompt"
                    data-visibility-tracker-one-shot
                    data-visibility-tracker-arg-page={pageUrl}
                    width={"full"}
                    colorScheme={"paywallSubscribePromptButtonBackground"}
                >
                    {templateSettings.paywall_subscribe_prompt_button_text}
                </Button>
            }
        </PaywallCard>
    );
};
